import { memo, PropsWithChildren } from 'react';

import { merge } from '@/components';
import { Flex, FlexProps, Heading, Text } from '@/components/core';

export type SectionProps = {
  title: string;
  description?: string;
} & FlexProps;

const ISection = ({ title, description, children, ...rest }: PropsWithChildren<SectionProps>) => {
  return (
    <Flex col className="gap-sm" {...rest}>
      <Flex col>
        <Heading size="sm">{title}</Heading>
        <Text size="sm">{description}</Text>
      </Flex>

      {children}
    </Flex>
  );
};

export type SectionCardProps = FlexProps;

const ISectionCard = ({ children, className, ...rest }: PropsWithChildren<SectionCardProps>) => {
  return (
    <Flex className={merge('gap-sm rounded-lg border border-gray-200 bg-white p-4 shadow-xs', className)} {...rest}>
      {children}
    </Flex>
  );
};

export const Section = memo(ISection);
export const SectionCard = memo(ISectionCard);
